<!--
  ~ Copyright (C) 2020 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
@if (configTypes$ | async; as configTypes) {
<div>
  <div class="config-type__wrapper">
    <og-legacy-multi-select
      [options]="configTypes"
      [selectedOption]="selectedConfigType"
      (selectionChange)="configTypeChange.emit($event)"
    ></og-legacy-multi-select>
  </div>
  @if (selectedConfigType) {
  <mat-tab-group>
    <!-- Current value -->
    <mat-tab>
      <ng-template mat-tab-label>
        @if (!isSelectedConfigValueLoading && selectedConfigValueError) {
        <mat-icon class="material-icons">
          error
        </mat-icon>
        } @if (isSelectedConfigValueLoading) {
        <mat-progress-spinner
          class="material-icons"
          mode="indeterminate"
          color="accent"
          diameter="30"
        ></mat-progress-spinner>
        } Current value
      </ng-template>
      <ngx-monaco-editor
        class="config-value__field"
        [options]="editorOptions"
        [ngModel]="selectedConfigValueData?.updated"
        (ngModelChange)="configValueChange.emit($event)"
      ></ngx-monaco-editor>
    </mat-tab>
    <!-- Default value -->
    @if (showDefaultValueTab) {
    <mat-tab>
      <ng-template mat-tab-label>
        @if (!isSelectedConfigDefaultValueLoading && selectedConfigDefaultValueError) {
        <mat-icon class="material-icons">
          error
        </mat-icon>
        } @if (isSelectedConfigDefaultValueLoading) {
        <mat-progress-spinner
          class="material-icons"
          mode="indeterminate"
          color="accent"
          diameter="30"
        ></mat-progress-spinner>
        } Default value
      </ng-template>
      <ngx-monaco-editor
        class="config-value__field"
        [options]="defaultEditorOptions"
        [ngModel]="selectedConfigDefaultValueData"
      ></ngx-monaco-editor>
    </mat-tab>
    }
  </mat-tab-group>
  } @else {
  <div>Select a config type to edit the associated value.</div>
  }
  <!-- Show all errors below the tabs -->
  @if (selectedConfigValueError; as errorMessage) {
  <span class="error-message">
    {{ errorMessage }}
  </span>
  } @if (selectedConfigDefaultValueError; as errorMessage) {
  <span class="error-message">
    {{ errorMessage }}
  </span>
  }
</div>
} @else {
<div>Loading config types...</div>
}
